export const fallbackBisURL = 'https://bis.bcapps.org';
export const bisURL = 'https://latam-bis.betconstruct.com';
export const bisApuestatotalAPIPath = 'api/apuestatotal';
export const bisBonanzaAPIPath = 'api/bonanza';